module.exports = __webpack_public_path__ + "img/winning.367a0ef5.jpeg";